import { NItems } from './interface';

export const baseReducer: NItems.Reducer = {
    layers: [],
    systemLayers: [],
    items: {},
    select: null,
    edit: null,
    crop: null
}